<!--
 * @Description: 属性配置新
 * @Author: WuPuyi
 * @LastEditors: ChenXueLin
 * @Date: 2021-04-19 11:33:49
 * @LastEditTime: 2022-06-14 13:42:55
-->
<template>
  <div class="content-view-wrapper pd-10">
    <div
      class="content-view"
      v-loading="loading"
      :element-loading-background="loadingBackground"
    >
      <section class="edit-wrapper">
        <div class="edit-wrapper__body">
          <div class="header-btn-box">
            <div class="switch-page-button">
              <el-button
                round
                :class="[clickIndex == index ? 'activeButton' : '']"
                @click="switchPage(index)"
                v-for="(btn, index) in configList"
                :key="index"
                >{{ btn.combinationName }}</el-button
              >
            </div>
          </div>
          <div>
            <div class="edit-title">实施要求</div>
            <div class="require-content">
              <div v-for="(require, index) in requireList" :key="index">
                {{ require }}
              </div>
            </div>
            <!-- <el-form label-width="80px" class="require-form">
              <el-form-item label="左侧盲区:"  v-for="(btn, index) in configList"
                :key="index"> 1111 </el-form-item>
              <el-form-item label="车头:"> 122 </el-form-item>
            </el-form> -->
          </div>
          <div>
            <div class="edit-title">属性配置</div>
            <el-form
              ref="form"
              label-width="120px"
              v-if="configList && configList.length"
            >
              <template>
                <div class="edit-content">
                  <el-row>
                    <div
                      v-for="config in configList[clickIndex][
                        'terminalAttrList'
                      ]"
                      :key="config.requireKey"
                    >
                      <el-col :span="config.objectType == 'string' ? 8 : 24">
                        <el-form-item
                          :label="config.requireName"
                          prop="islock"
                          v-if="config.objectType == 'string'"
                        >
                          <el-radio-group
                            v-model="config.requireValue"
                            :disabled="config.indexSort == 999 ? true : false"
                            v-if="
                              !(
                                config.requireKey == 'oilControl' ||
                                config.requireKey == 'equipSourceId'
                              )
                            "
                          >
                            <el-radio label="1">是</el-radio>
                            <el-radio label="0">否</el-radio>
                          </el-radio-group>
                          <span v-else>:{{ config.requireValue }}</span>
                        </el-form-item>

                        <el-form-item
                          :label="config.requireName"
                          v-if="
                            config.objectType == 'list' &&
                            (config.requireKey != 'sensor' ||
                              (config.requireKey == 'sensor' &&
                                configList[clickIndex].sensorAppList &&
                                configList[clickIndex].sensorAppList.length))
                          "
                        >
                          <div
                            class="camera-ways-wrapper"
                            v-if="
                              config.requireKey === 'cameraWays' &&
                              isZiBaoHe == 1
                            "
                          >
                            <el-checkbox-group
                              v-model="config.channel"
                              :disabled="config.indexSort == 999 ? true : false"
                              @change="handleCameraChannelChange"
                            >
                              <div
                                class="camera-ways-item"
                                v-for="item in keyConfig[config.requireKey]"
                                :key="item.value"
                              >
                                <el-checkbox
                                  :label="item.value"
                                  :disabled="
                                    config.isReadOnlyChannel &&
                                    config.isReadOnlyChannel.includes(
                                      item.value
                                    )
                                      ? true
                                      : false
                                  "
                                  @change="
                                    handleItemCameraChannelChange(item.value)
                                  "
                                  >{{ item.title }}</el-checkbox
                                >
                                <el-select
                                  v-model="
                                    ziBaoHeCameraProductMap['CH' + item.value]
                                  "
                                  placeholder="请选择"
                                  :disabled="
                                    isSelectDisabled(item.value, config.channel)
                                  "
                                  :ref="`cameraSelect${item.value}`"
                                  :class="{
                                    'is-error':
                                      cameraSelectErrors[`CH${item.value}`]
                                  }"
                                  @change="
                                    clearCameraSelectError(`CH${item.value}`)
                                  "
                                >
                                  <el-option
                                    v-for="typeItem in cameraTypeList[
                                      item.typeKey
                                    ]"
                                    :key="typeItem.positionName"
                                    :label="typeItem.positionName"
                                    :value="typeItem.positionName"
                                  >
                                  </el-option>
                                </el-select>
                                <div
                                  v-if="cameraSelectErrors[`CH${item.value}`]"
                                  class="el-form-item__error"
                                >
                                  请选择摄像头类型
                                </div>
                              </div>
                            </el-checkbox-group>
                          </div>
                          <!-- 门磁安装位置下拉(isZiBaoHeV2) -->
                          <div
                            class="camera-ways-wrapper"
                            :class="{
                              'equip-code-wrapper':
                                hasWirelessGateway && isZiBaoHeV2
                            }"
                            v-else-if="
                              config.requireKey === 'doorSensorWays' &&
                              isZiBaoHeV2
                            "
                          >
                            <el-checkbox-group
                              v-model="config.channel"
                              :disabled="config.indexSort == 999 ? true : false"
                              @change="handleDoorSensorChannelChange"
                            >
                              <div
                                class="camera-ways-item"
                                v-for="item in keyConfig[config.requireKey]"
                                :key="item.value"
                              >
                                <el-checkbox
                                  :label="item.value"
                                  :disabled="
                                    config.isReadOnlyChannel &&
                                    config.isReadOnlyChannel.includes(
                                      item.value
                                    )
                                      ? true
                                      : false
                                  "
                                  >{{ item.title }}</el-checkbox
                                >
                                <el-select
                                  v-model="
                                    ziBaoHeDoorSensorProductMap['CH' + item.value]
                                  "
                                  placeholder="请选择安装位置"
                                  :disabled="
                                    !config.channel.includes(item.value)
                                  "
                                  :ref="`doorSensorSelect${item.value}`"
                                  :class="{
                                    'is-error':
                                      doorSensorSelectErrors[`CH${item.value}`]
                                  }"
                                  @change="
                                    clearDoorSensorSelectError(`CH${item.value}`)
                                  "
                                >
                                  <el-option
                                    v-for="posItem in doorSensorPositionList[
                                      'CH' + item.value
                                    ]"
                                    :key="posItem.positionCode"
                                    :label="posItem.positionName"
                                    :value="posItem.positionCode"
                                  >
                                  </el-option>
                                </el-select>
                                <!-- 无线网关时，位置后追加设备号输入框+选择设备按钮 -->
                                <div
                                  v-if="hasWirelessGateway && isZiBaoHeV2"
                                  class="equip-code-row"
                                >
                                  <el-input
                                    v-model="
                                      ziBaoHeDoorSensorEquipCodeMap[
                                        'CH' + item.value
                                      ]
                                    "
                                    placeholder="请输入设备号"
                                    :disabled="
                                      !config.channel.includes(item.value)
                                    "
                                    class="equip-code-input"
                                    :class="{
                                      'is-error':
                                        doorSensorEquipCodeErrors[
                                          `CH${item.value}`
                                        ]
                                    }"
                                    maxlength="64"
                                    @input="
                                      clearDoorSensorEquipCodeError(
                                        `CH${item.value}`
                                      )
                                    "
                                  ></el-input>
                                  <el-button
                                    type="text"
                                    class="equip-code-select-btn"
                                    :disabled="
                                      !config.channel.includes(item.value)
                                    "
                                    @click="
                                      openEquipCodeDialog('door', item.value)
                                    "
                                    >选择设备</el-button
                                  >
                                </div>
                                <div
                                  v-if="doorSensorSelectErrors[`CH${item.value}`]"
                                  class="el-form-item__error"
                                >
                                  请选择门磁安装位置
                                </div>
                                <div
                                  v-if="
                                    doorSensorEquipCodeErrors[`CH${item.value}`]
                                  "
                                  class="el-form-item__error"
                                >
                                  请输入门磁设备号
                                </div>
                              </div>
                            </el-checkbox-group>
                          </div>
                          <!-- 温控安装位置下拉(isZiBaoHeV2) -->
                          <div
                            class="camera-ways-wrapper"
                            :class="{
                              'equip-code-wrapper':
                                hasWirelessGateway && isZiBaoHeV2
                            }"
                            v-else-if="
                              config.requireKey === 'temperatureWays' &&
                              isZiBaoHeV2
                            "
                          >
                            <el-checkbox-group
                              v-model="config.channel"
                              :disabled="config.indexSort == 999 ? true : false"
                              @change="handleTemperatureChannelChange"
                            >
                              <div
                                class="camera-ways-item"
                                v-for="item in keyConfig[config.requireKey]"
                                :key="item.value"
                              >
                                <el-checkbox
                                  :label="item.value"
                                  :disabled="
                                    config.isReadOnlyChannel &&
                                    config.isReadOnlyChannel.includes(
                                      item.value
                                    )
                                      ? true
                                      : false
                                  "
                                  >{{ item.title }}</el-checkbox
                                >
                                <el-select
                                  v-model="
                                    ziBaoHeTemperatureProductMap['CH' + item.value]
                                  "
                                  placeholder="请选择安装位置"
                                  :disabled="
                                    !config.channel.includes(item.value)
                                  "
                                  :ref="`temperatureSelect${item.value}`"
                                  :class="{
                                    'is-error':
                                      temperatureSelectErrors[`CH${item.value}`]
                                  }"
                                  @change="
                                    clearTemperatureSelectError(`CH${item.value}`)
                                  "
                                >
                                  <el-option
                                    v-for="posItem in temperaturePositionList[
                                      'CH' + item.value
                                    ]"
                                    :key="posItem.positionCode"
                                    :label="posItem.positionName"
                                    :value="posItem.positionCode"
                                  >
                                  </el-option>
                                </el-select>
                                <!-- 无线网关时，位置后追加设备号输入框+选择设备按钮 -->
                                <div
                                  v-if="hasWirelessGateway && isZiBaoHeV2"
                                  class="equip-code-row"
                                >
                                  <el-input
                                    v-model="
                                      ziBaoHeTemperatureEquipCodeMap[
                                        'CH' + item.value
                                      ]
                                    "
                                    placeholder="请输入设备号"
                                    :disabled="
                                      !config.channel.includes(item.value)
                                    "
                                    class="equip-code-input"
                                    :class="{
                                      'is-error':
                                        temperatureEquipCodeErrors[
                                          `CH${item.value}`
                                        ]
                                    }"
                                    maxlength="64"
                                    @input="
                                      clearTemperatureEquipCodeError(
                                        `CH${item.value}`
                                      )
                                    "
                                  ></el-input>
                                  <el-button
                                    type="text"
                                    class="equip-code-select-btn"
                                    :disabled="
                                      !config.channel.includes(item.value)
                                    "
                                    @click="
                                      openEquipCodeDialog(
                                        'temperature',
                                        item.value
                                      )
                                    "
                                    >选择设备</el-button
                                  >
                                </div>
                                <div
                                  v-if="temperatureSelectErrors[`CH${item.value}`]"
                                  class="el-form-item__error"
                                >
                                  请选择温控安装位置
                                </div>
                                <div
                                  v-if="
                                    temperatureEquipCodeErrors[
                                      `CH${item.value}`
                                    ]
                                  "
                                  class="el-form-item__error"
                                >
                                  请输入温控设备号
                                </div>
                              </div>
                            </el-checkbox-group>
                          </div>
                          <div v-else-if="config.requireKey != 'sensor'">
                            <el-checkbox-group
                              v-model="config.channel"
                              :disabled="config.indexSort == 999 ? true : false"
                            >
                              <el-checkbox
                                :label="item.value"
                                v-for="item in keyConfig[config.requireKey]"
                                :key="item.value"
                                :disabled="
                                  config.isReadOnlyChannel &&
                                  config.isReadOnlyChannel.includes(item.value)
                                    ? true
                                    : false
                                "
                                >{{ item.title }}</el-checkbox
                              >
                            </el-checkbox-group>
                          </div>
                          <!-- 传感器应用后续添加 -->
                          <div v-else>
                            <el-checkbox-group v-model="config.channel">
                              <el-checkbox
                                :label="item.id"
                                v-for="item in configList[clickIndex]
                                  .sensorAppList"
                                :key="item.id"
                                >{{ item.appName }}</el-checkbox
                              >
                            </el-checkbox-group>
                          </div>
                        </el-form-item>
                      </el-col>

                      <!-- TODO: 传感器应用后续添加 -->
                      <!-- <el-form-item
                      label="传感器应用"
                      v-if="
                        config.objectType == 'list' &&
                          config.requireKey == 'sensor' &&
                          configList &&
                          configList[clickIndex].sensorAppList.length
                      "
                    >
                      <el-checkbox-group v-model="config.channel">
                        <el-checkbox
                          :label="item.id"
                          v-for="item in configList[clickIndex].sensorAppList"
                          :key="item.id"
                          >{{ item.appName }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </el-form-item> -->
                    </div>
                  </el-row>
                </div>
              </template>
            </el-form>
          </div>
        </div>

        <!-- </div> -->
        <div class="edit-wrapper__footer">
          <!-- 新增属性 -->
          <el-button class="cancel" @click="handleGoBack(false)"
            >取消</el-button
          >
          <el-button
            v-if="itemStatus != 8"
            type="primary"
            @click="handleSaveAdd"
            >确定</el-button
          >
        </div>
      </section>
    </div>

    <!-- 选择设备弹框：数据来源queryWirelessGatewayEquipCodes，门磁取door_bluetooth，温控取temperature_bluetooth -->
    <el-dialog
      title="选择设备"
      v-dialogDrag
      :visible.sync="equipCodeDialogVisible"
      width="480px"
      append-to-body
    >
      <div
        v-if="currentEquipCodeOptions.length"
        class="equip-code-dialog-body"
      >
        <el-radio-group v-model="equipCodeDialogSelected">
          <el-radio
            v-for="code in currentEquipCodeOptions"
            :key="code"
            :label="code"
            :disabled="isEquipCodeOccupied(code)"
            >{{ code }}</el-radio
          >
        </el-radio-group>
      </div>
      <el-empty
        v-else
        description="暂无可选设备号"
        :image-size="80"
      ></el-empty>
      <!-- append-to-body 使弹框脱离组件根节点，scoped 样式无法命中，用 inline 样式居中按钮 -->
      <span slot="footer" style="display: block; text-align: center">
        <el-button @click="equipCodeDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :disabled="!equipCodeDialogSelected"
          @click="confirmEquipCodeSelect"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <!--   @handleClose="handleClose"
      @refresh="initForm" -->
  </div>
</template>

<script>
import base from "@/mixins/base";
import { printError } from "@/utils/util";
import goBack from "@/mixins/goBack";
import {
  getTerminalAttrConfigure,
  updateAttribute,
  getSensorList,
  findDownList,
  queryPositionList,
  queryDoorPositionList,
  queryColdPositionList,
  queryWirelessGatewayEquipCodes,
  getImplementRequire
} from "@/api";

export default {
  components: {},
  name: "newAttributeConfig",
  mixins: [base, goBack],
  data() {
    return {
      configList: [],
      itemStatus: "",
      // 新增终端属性
      dialogFormVisible: false,
      clickIndex: 0,
      isZiBaoHe: 0,
      zibaoheType: 0,
      cameraTypeList: {
        CH1: [],
        CH2: [],
        CH3: [],
        CH4: [],
        CH5: [],
        CH6: [],
        CH7: [],
        CH8: []
      },
      ziBaoHeCameraProductMap: {
        CH1: null,
        CH2: null,
        CH3: null,
        CH4: null,
        CH5: null,
        CH6: null,
        CH7: null,
        CH8: null
      },
      initialValueChannels: [], // 记录初始就有值的通道(1-6路)
      reSelectedChannels: [], // 记录重新勾选的通道
      cameraSelectErrors: {}, // 记录摄像头select的错误状态
      doorSensorSelectErrors: {}, // 记录门磁select的错误状态
      temperatureSelectErrors: {}, // 记录温控select的错误状态
      doorSensorEquipCodeErrors: {}, // 记录门磁设备号输入框的错误状态
      temperatureEquipCodeErrors: {}, // 记录温控设备号输入框的错误状态
      locationChangeVisible: false,
      requireList: [], //实施要求列表
      isZiBaoHeV2: false, // 紫宝盒V2标识
      hasWirelessGateway: false, // 无线网关标识
      temperatureSensor: null,
      temperatureSum: null,
      doorSensor: null,
      doorSum: null, // 紫宝盒V2门磁最大路数
      doorSensorPositionList: {}, // 门磁安装位置选项（动态初始化）
      temperaturePositionList: {}, // 温控安装位置选项（动态初始化）
      ziBaoHeDoorSensorProductMap: {}, // 门磁选中值(存positionCode，动态初始化)
      ziBaoHeTemperatureProductMap: {}, // 温控选中值(存positionCode，动态初始化)
      ziBaoHeDoorSensorEquipCodeMap: {}, // 门磁设备号(动态初始化，key为CH1~CH{doorSum})
      ziBaoHeTemperatureEquipCodeMap: {}, // 温控设备号(动态初始化，key为CH1~CH{temperatureSum})
      wirelessGatewayEquipCodes: {
        door_bluetooth: [],
        temperature_bluetooth: []
      }, // 无线网关候选设备号(按当前组合缓存)
      equipCodeDialogVisible: false, // 选择设备弹框显隐
      equipCodeDialogType: "", // 弹框服务模块："door" | "temperature"
      equipCodeDialogChannel: null, // 弹框目标通道号
      equipCodeDialogSelected: "" // 弹框内当前选中的设备号
    };
  },
  created() {
    let hasParamsRoute = this.getHasParamsRoute();
    this.itemId = hasParamsRoute.params.itemId;
    this.itemStatus = hasParamsRoute.params.itemStatus;
    if (this.itemId) {
      this.taskId = hasParamsRoute.params.taskId;
      this.getAttrReq();
    }
    this.getImplementRequire();
  },
  computed: {
    keyConfig() {
      // 工具方法：动态生成路数选项
      function buildWayOptions(count) {
        const chineseNumMap = [
          "", "一", "二", "三", "四", "五", "六", "七", "八",
          "九", "十", "十一", "十二", "十三", "十四", "十五", "十六"
        ];
        return Array.from({ length: count }, (_, i) => ({
          title: `${chineseNumMap[i + 1]}路`,
          value: i + 1
        }));
      }
      let result;
      if (this.isZiBaoHe == 1) {
        let cameraWays;
        if (this.isZiBaoHeV2 && this.zibaoheType == 1) {
          cameraWays = [
            { title: "一路", value: 1, typeKey: "CH1" },
            { title: "二路", value: 2, typeKey: "CH2" },
            { title: "三路", value: 3, typeKey: "CH3" },
            { title: "四路", value: 4, typeKey: "CH4" }
          ];
        } else {
          cameraWays = [
            { title: "一路", value: 1, typeKey: "CH1" },
            { title: "二路", value: 2, typeKey: "CH2" },
            { title: "三路", value: 3, typeKey: "CH3" },
            { title: "四路", value: 4, typeKey: "CH4" },
            { title: "五路", value: 5, typeKey: "CH5" },
            { title: "六路", value: 6, typeKey: "CH6" },
            { title: "七路", value: 7, typeKey: "CH7" },
            { title: "八路", value: 8, typeKey: "CH8" }
          ];
        }
        result = {
          cameraWays,
          //k5摄像头
          k5DvrVideoNumber: [
            { title: "一路", value: 1 },
            { title: "二路", value: 2 },
            { title: "三路", value: 3 },
            { title: "四路", value: 4 },
            { title: "五路", value: 5 },
            { title: "六路", value: 6 },
            { title: "七路", value: 7 },
            { title: "八路", value: 8 },
            { title: "九路", value: 9 },
            { title: "十路", value: 10 },
            { title: "十一路", value: 11 },
            { title: "十二路", value: 12 },
            { title: "十三路", value: 13 },
            { title: "十四路", value: 14 },
            { title: "十五路", value: 15 },
            { title: "十六路", value: 16 }
          ],
          //门磁（V2时路数由doorSum控制，否则4路）
          doorSensorWays: buildWayOptions(
            this.isZiBaoHeV2 ? this.doorSum || 4 : 4
          ),
          //湿度16路
          humidnessWays: [
            { title: "一路", value: 1 },
            { title: "二路", value: 2 },
            { title: "三路", value: 3 },
            { title: "四路", value: 4 },
            { title: "五路", value: 5 },
            { title: "六路", value: 6 },
            { title: "七路", value: 7 },
            { title: "八路", value: 8 },
            { title: "九路", value: 9 },
            { title: "十路", value: 10 },
            { title: "十一路", value: 11 },
            { title: "十二路", value: 12 },
            { title: "十三路", value: 13 },
            { title: "十四路", value: 14 },
            { title: "十五路", value: 15 },
            { title: "十六路", value: 16 }
          ],
          //温控（V2时路数由temperatureSum控制，否则16路）
          temperatureWays: buildWayOptions(
            this.isZiBaoHeV2 ? this.temperatureSum || 4 : 16
          )
        };
      } else {
        result = {
          //摄像头
          cameraWays: [
            {
              title: "一路",
              value: 1
            },
            {
              title: "二路",
              value: 2
            },
            {
              title: "三路",
              value: 3
            },
            {
              title: "四路",
              value: 4
            },
            {
              title: "五路",
              value: 5
            },
            {
              title: "六路",
              value: 6
            },
            {
              title: "七路",
              value: 7
            },
            {
              title: "八路",
              value: 8
            },
            {
              title: "九路",
              value: 9
            },
            {
              title: "十路",
              value: 10
            },
            {
              title: "十一路",
              value: 11
            },
            {
              title: "十二路",
              value: 12
            },
            {
              title: "十三路",
              value: 13
            },
            {
              title: "十四路",
              value: 14
            },
            {
              title: "十五路",
              value: 15
            },
            {
              title: "十六路",
              value: 16
            }
          ],
          //k5摄像头
          k5DvrVideoNumber: [
            {
              title: "一路",
              value: 1
            },
            {
              title: "二路",
              value: 2
            },
            {
              title: "三路",
              value: 3
            },
            {
              title: "四路",
              value: 4
            },
            {
              title: "五路",
              value: 5
            },
            {
              title: "六路",
              value: 6
            },
            {
              title: "七路",
              value: 7
            },
            {
              title: "八路",
              value: 8
            },
            {
              title: "九路",
              value: 9
            },
            {
              title: "十路",
              value: 10
            },
            {
              title: "十一路",
              value: 11
            },
            {
              title: "十二路",
              value: 12
            },
            {
              title: "十三路",
              value: 13
            },
            {
              title: "十四路",
              value: 14
            },
            {
              title: "十五路",
              value: 15
            },
            {
              title: "十六路",
              value: 16
            }
          ],
          //门磁4路
          doorSensorWays: [
            {
              title: "一路",
              value: 1
            },
            {
              title: "二路",
              value: 2
            },
            {
              title: "三路",
              value: 3
            },
            {
              title: "四路",
              value: 4
            }
          ],
          //湿度16路
          humidnessWays: [
            {
              title: "一路",
              value: 1
            },
            {
              title: "二路",
              value: 2
            },
            {
              title: "三路",
              value: 3
            },
            {
              title: "四路",
              value: 4
            },
            {
              title: "五路",
              value: 5
            },
            {
              title: "六路",
              value: 6
            },
            {
              title: "七路",
              value: 7
            },
            {
              title: "八路",
              value: 8
            },
            {
              title: "九路",
              value: 9
            },
            {
              title: "十路",
              value: 10
            },
            {
              title: "十一路",
              value: 11
            },
            {
              title: "十二路",
              value: 12
            },
            {
              title: "十三路",
              value: 13
            },
            {
              title: "十四路",
              value: 14
            },
            {
              title: "十五路",
              value: 15
            },
            {
              title: "十六路",
              value: 16
            }
          ],
          //温控（16路）
          temperatureWays: [
            {
              title: "一路",
              value: 1
            },
            {
              title: "二路",
              value: 2
            },
            {
              title: "三路",
              value: 3
            },
            {
              title: "四路",
              value: 4
            },
            {
              title: "五路",
              value: 5
            },
            {
              title: "六路",
              value: 6
            },
            {
              title: "七路",
              value: 7
            },
            {
              title: "八路",
              value: 8
            },
            {
              title: "九路",
              value: 9
            },
            {
              title: "十路",
              value: 10
            },
            {
              title: "十一路",
              value: 11
            },
            {
              title: "十二路",
              value: 12
            },
            {
              title: "十三路",
              value: 13
            },
            {
              title: "十四路",
              value: 14
            },
            {
              title: "十五路",
              value: 15
            },
            {
              title: "十六路",
              value: 16
            }
          ]
        };
      }
      // isZiBaoHeV2时temperatureWays按接口返回的通道过滤
      if (this.isZiBaoHeV2 && result.temperatureWays) {
        const channels = this.temperatureChannels;
        if (Array.isArray(channels) && channels.length) {
          result.temperatureWays = result.temperatureWays.filter((item) =>
            channels.includes(item.value)
          );
        } else {
          result.temperatureWays = result.temperatureWays.filter(
            (item) => item.value <= (this.temperatureSum || 4)
          );
        }
      }
      return result;
    },
    // 选择设备弹框数据源：门磁取door_bluetooth，温控取temperature_bluetooth
    currentEquipCodeOptions() {
      return this.equipCodeDialogType === "door"
        ? this.wirelessGatewayEquipCodes.door_bluetooth
        : this.wirelessGatewayEquipCodes.temperature_bluetooth;
    }
  },
  methods: {
    //获取属性默认值
    async getAttrReq() {
      try {
        let res = await getTerminalAttrConfigure({
          id: this.itemId
        });
        const attrItem = res.data[this.clickIndex];
        this.isZiBaoHe = attrItem.isZiBaoHe;
        this.zibaoheType = attrItem.zibaoheType;
        this.isZiBaoHeV2 = attrItem.isZiBaoHeV2 === true;
        this.hasWirelessGateway = attrItem.hasWirelessGateway === true;
        this.temperatureSensor = attrItem.temperatureSensor;
        this.temperatureSum = attrItem.temperatureSum;
        this.doorSensor = attrItem.doorSensor;
        this.temperatureSum = attrItem.temperatureSum;
        this.doorSum = attrItem.doorSum;
        this.temperatureChannels = attrItem.temperatureChannels;
        this.doorChannels = attrItem.doorChannels;
        this.configList = this.buildData(res.data);
        console.log(this.configList, 1122);
        // V2时动态初始化门磁/温控的productMap和positionList key
        if (this.isZiBaoHeV2) {
          this.initDynamicMaps();
        }
        // 并行查询所有位置列表，全部完成后再反显productTagMap
        await Promise.all([
          this.queryCameraPositionList(),
          this.isZiBaoHeV2 && this.doorSensor ? this.queryDoorPositionListReq() : Promise.resolve(),
          this.isZiBaoHeV2 && this.temperatureSensor ? this.queryColdPositionListReq() : Promise.resolve(),
          this.hasWirelessGateway && this.isZiBaoHeV2 ? this.queryWirelessGatewayEquipCodesReq() : Promise.resolve()
        ]);
        this.reflectProductTagMap();
        this.getSensorList();
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    async getCameraTypeList() {
      const res = await findDownList([
        "CH1",
        "CH2",
        "CH3",
        "CH4",
        "CH5",
        "CH6",
        "CH78"
      ]);
      let cameraTypeList = res.data || {};
      console.log(cameraTypeList, "1146~~~");
      // 因为回显接口没返回id，需要通过name从列表项中去补全初始数据
      // for (
      //   let i = 0;
      //   i < this.configList[this.clickIndex].terminalAttrList.length;
      //   i++
      // ) {
      //   const item = this.configList[this.clickIndex].terminalAttrList[i];
      //   if (item.requireKey === "cameraWays") {
      //     // 记录初始有值的通道(前6路)
      //     this.initialValueChannels = [];
      //     // 重置重新勾选的通道列表
      //     this.reSelectedChannels = [];
      //     for (const key in item.productTagMap) {
      //       const channelNum = parseInt(key);
      //       if (channelNum <= 6) {
      //         this.initialValueChannels.push(channelNum);
      //       }
      //       this.ziBaoHeCameraProductMap[`CH${key}`] = item.productTagMap[key];
      //     }
      //   }
      // }
    },
    //查询摄像头安装位置
    async queryCameraPositionList() {
      let res = await queryPositionList({ id: this.itemId });
      this.cameraTypeList = res.data.reduce((result, item) => {
        const key = `CH${item.channel}`;
        result[key] = item.positionList.map((position) => ({
          positionName: position.positionName,
          positionCode: position.positionCode
        }));
        return result;
      }, {});
    },
    //查询门磁安装位置
    async queryDoorPositionListReq() {
      let res = await queryDoorPositionList({
        itemId: this.itemId,
        doorSensor: this.doorSensor,
        doorSum: this.doorSum,
        doorChannels: this.doorChannels,
        key: this.doorSensor
      });
      this.doorSensorPositionList = (res.data || []).reduce((result, item) => {
        const key = `CH${item.channel}`;
        result[key] = (item.positionList || []).map((position) => ({
          positionName: position.positionName,
          positionCode: position.positionCode
        }));
        return result;
      }, {});
    },
    //查询温控安装位置
    async queryColdPositionListReq() {
      let res = await queryColdPositionList({
        itemId: this.itemId,
        temperatureSensor: this.temperatureSensor,
        temperatureSum: this.temperatureSum,
        temperatureChannels: this.temperatureChannels,
        key: this.temperatureSensor
      });
      this.temperaturePositionList = (res.data || []).reduce((result, item) => {
        const key = `CH${item.channel}`;
        result[key] = (item.positionList || []).map((position) => ({
          positionName: position.positionName,
          positionCode: position.positionCode
        }));
        return result;
      }, {});
    },
    //查询无线网关候选设备号
    async queryWirelessGatewayEquipCodesReq() {
      try {
        const res = await queryWirelessGatewayEquipCodes({
          itemId: this.itemId,
          combinationId: this.configList[this.clickIndex].combinationId
        });
        if (res.code == "OK") {
          const data = res.data || {};
          this.wirelessGatewayEquipCodes = {
            door_bluetooth: data.door_bluetooth || [],
            temperature_bluetooth: data.temperature_bluetooth || []
          };
        }
      } catch (error) {
        printError(error);
      }
    },
    //反显productTagMap：位置列表加载完成后，将positionCode映射为positionName用于显示
    reflectProductTagMap() {
      for (
        let i = 0;
        i < this.configList[this.clickIndex].terminalAttrList.length;
        i++
      ) {
        const item = this.configList[this.clickIndex].terminalAttrList[i];
        if (item.requireKey === "cameraWays" && this.isZiBaoHe == 1) {
          this.initialValueChannels = [];
          this.reSelectedChannels = [];
          for (const key in item.productTagMap) {
            const channelNum = parseInt(key);
            if (channelNum <= 6) {
              this.initialValueChannels.push(channelNum);
            }
            const channelKey = `CH${key}`;
            const positionItem = (this.cameraTypeList[channelKey] || []).find(
              (p) => p.positionCode === item.productTagMap[key]
            );
            this.ziBaoHeCameraProductMap[channelKey] = positionItem
              ? positionItem.positionName
              : item.productTagMap[key];
          }
        }
        if (item.requireKey === "doorSensorWays" && this.isZiBaoHeV2) {
          for (const key in item.productTagMap) {
            const channelKey = `CH${key}`;
            const positionItem = (this.doorSensorPositionList[channelKey] || []).find(
              (p) => p.positionCode === item.productTagMap[key]
            );
            this.ziBaoHeDoorSensorProductMap[channelKey] = positionItem
              ? positionItem.positionName
              : item.productTagMap[key];
          }
          // 回显门磁设备号
          for (const key in item.equipCodeMap || {}) {
            this.$set(
              this.ziBaoHeDoorSensorEquipCodeMap,
              `CH${key}`,
              item.equipCodeMap[key]
            );
          }
        }
        if (item.requireKey === "temperatureWays" && this.isZiBaoHeV2) {
          for (const key in item.productTagMap) {
            const channelKey = `CH${key}`;
            const positionItem = (this.temperaturePositionList[channelKey] || []).find(
              (p) => p.positionCode === item.productTagMap[key]
            );
            this.ziBaoHeTemperatureProductMap[channelKey] = positionItem
              ? positionItem.positionName
              : item.productTagMap[key];
          }
          // 回显温控设备号
          for (const key in item.equipCodeMap || {}) {
            this.$set(
              this.ziBaoHeTemperatureEquipCodeMap,
              `CH${key}`,
              item.equipCodeMap[key]
            );
          }
        }
      }
    },
    //查询实施要求
    async getImplementRequire() {
      let res = await getImplementRequire({ id: this.itemId });
      this.requireList = res.data;
    },
    //重构数据
    buildData(configList) {
      // let configList = this.configList;
      let combinationId = configList[this.clickIndex].combinationId;
      let itemId = configList[this.clickIndex].itemId;
      let taskId = configList[this.clickIndex].taskId;
      this.isZiBaoHe = configList[this.clickIndex].isZiBaoHe;
      this.zibaoheType = configList[this.clickIndex].zibaoheType;
      let keysObject = {
        cameraWays: {
          channel: [],
          requireKey: "cameraWays",
          requireName: "摄像头",
          combinationId,
          itemId,
          objectType: "list",
          requireId: "",
          taskId,
          code: "1",
          indexSort: 2
        },
        humidnessWays: {
          code: "68",
          channel: [],
          requireKey: "humidnessWays",
          requireName: "湿度",
          combinationId,
          itemId,
          objectType: "list",
          requireId: "",
          taskId,
          indexSort: 5
        },
        doorSensorWays: {
          code: "3",
          channel: [],
          requireKey: "doorSensorWays",
          requireName: "门磁",
          combinationId,
          itemId,
          objectType: "list",
          requireId: "",
          taskId,
          indexSort: 3
        },
        temperatureWays: {
          code: "4",
          channel: [],
          requireKey: "temperatureWays",
          requireName: "温控",
          combinationId,
          itemId,
          objectType: "list",
          requireId: "",
          taskId,
          indexSort: 4
        }
      };
      configList.map((item) => {
        for (let key in keysObject) {
          if (!item.terminalAttrList.some((ele) => ele.requireKey == key)) {
            item.terminalAttrList.push(keysObject[key]);
          }
        }
      });
      return configList;
    },
    async getSensorList() {
      try {
        let res = await getSensorList({
          appName: "",
          equThirdTypeId: this.configList[this.clickIndex].thirdClassId,
          sensors: ""
        });
        if (res.code == "OK") {
          let configList = this.configList;
          this.$set(configList[this.clickIndex], "sensorAppList", res.data);
          this.configList = configList;
        }
      } catch (error) {
        printError(error);
      }
    },

    //选择组合
    switchPage(idx) {
      this.clickIndex = idx;
      this.isZiBaoHe = this.configList[this.clickIndex].isZiBaoHe;
      this.zibaoheType = this.configList[this.clickIndex].zibaoheType;
      this.isZiBaoHeV2 = this.configList[this.clickIndex].isZiBaoHeV2 === true;
      this.hasWirelessGateway =
        this.configList[this.clickIndex].hasWirelessGateway === true;
      this.temperatureSum = this.configList[this.clickIndex].temperatureSum;
      this.doorSum = this.configList[this.clickIndex].doorSum;
      // V2时动态初始化门磁/温控的productMap和positionList key
      if (this.isZiBaoHeV2) {
        this.initDynamicMaps();
      }
      // 网关组合：候选设备号随组合刷新；非网关组合清空缓存防止串扰
      if (this.hasWirelessGateway && this.isZiBaoHeV2) {
        this.queryWirelessGatewayEquipCodesReq();
      } else {
        this.wirelessGatewayEquipCodes = {
          door_bluetooth: [],
          temperature_bluetooth: []
        };
      }
      // 重置重新勾选的通道状态
      this.reSelectedChannels = [];
      this.initialValueChannels = [];
      if (!this.configList[this.clickIndex].thirdClassId) return;
      this.getSensorList();
      // 切换组合后需重新反显摄像头类型(ziBaoHeCameraProductMap),
      // 否则切换到非首位的紫宝盒组合时,摄像头select无法回显已保存的类型
      this.reflectProductTagMap();
      this.$forceUpdate();
    },
    // V2时动态初始化门磁/温控的productMap和positionList的CH key
    initDynamicMaps() {
      const doorMax = this.doorSum || 4;
      const tempMax = this.temperatureSum || 4;
      for (let i = 1; i <= doorMax; i++) {
        const key = `CH${i}`;
        if (!(key in this.ziBaoHeDoorSensorProductMap)) {
          this.$set(this.ziBaoHeDoorSensorProductMap, key, null);
        }
        if (!(key in this.doorSensorPositionList)) {
          this.$set(this.doorSensorPositionList, key, []);
        }
        if (!(key in this.ziBaoHeDoorSensorEquipCodeMap)) {
          this.$set(this.ziBaoHeDoorSensorEquipCodeMap, key, "");
        }
      }
      for (let i = 1; i <= tempMax; i++) {
        const key = `CH${i}`;
        if (!(key in this.ziBaoHeTemperatureProductMap)) {
          this.$set(this.ziBaoHeTemperatureProductMap, key, null);
        }
        if (!(key in this.temperaturePositionList)) {
          this.$set(this.temperaturePositionList, key, []);
        }
        if (!(key in this.ziBaoHeTemperatureEquipCodeMap)) {
          this.$set(this.ziBaoHeTemperatureEquipCodeMap, key, "");
        }
      }
    },
    // 更新设备属性
    async updateHostAttribute() {
      let configList = _.cloneDeep(this.configList);
      configList.map((item) => {
        item.terminalAttrList = item.terminalAttrList.filter(
          (ele) => ele.requireId || (!ele.requireId && ele.channel.length)
        );
        // 如果是紫宝盒，将productTagMap格式化后塞到cameraWays
        if (this.isZiBaoHe == 1) {
          for (const i in item.terminalAttrList) {
            if (item.terminalAttrList[i].requireKey === "cameraWays") {
              const formatMap = {};
              for (const key in this.ziBaoHeCameraProductMap) {
                if (this.ziBaoHeCameraProductMap[key]) {
                  formatMap[key.slice(2)] = this.ziBaoHeCameraProductMap[key];
                }
              }
              item.terminalAttrList[i].productTagMap = formatMap;
            }
          }
        }
        // isZiBaoHeV2时，格式化doorSensorWays和temperatureWays的productTagMap/equipCodeMap
        if (this.isZiBaoHeV2) {
          for (const i in item.terminalAttrList) {
            if (item.terminalAttrList[i].requireKey === "doorSensorWays") {
              const formatMap = {};
              const equipCodeMap = {};
              for (const key in this.ziBaoHeDoorSensorProductMap) {
                if (this.ziBaoHeDoorSensorProductMap[key]) {
                  formatMap[key.slice(2)] = this.ziBaoHeDoorSensorProductMap[key];
                }
              }
              for (const key in this.ziBaoHeDoorSensorEquipCodeMap) {
                if (this.ziBaoHeDoorSensorEquipCodeMap[key]) {
                  equipCodeMap[key.slice(2)] = this.ziBaoHeDoorSensorEquipCodeMap[key];
                }
              }
              item.terminalAttrList[i].productTagMap = formatMap;
              item.terminalAttrList[i].equipCodeMap = equipCodeMap;
            }
            if (item.terminalAttrList[i].requireKey === "temperatureWays") {
              const formatMap = {};
              const equipCodeMap = {};
              for (const key in this.ziBaoHeTemperatureProductMap) {
                if (this.ziBaoHeTemperatureProductMap[key]) {
                  formatMap[key.slice(2)] = this.ziBaoHeTemperatureProductMap[key];
                }
              }
              for (const key in this.ziBaoHeTemperatureEquipCodeMap) {
                if (this.ziBaoHeTemperatureEquipCodeMap[key]) {
                  equipCodeMap[key.slice(2)] = this.ziBaoHeTemperatureEquipCodeMap[key];
                }
              }
              item.terminalAttrList[i].productTagMap = formatMap;
              item.terminalAttrList[i].equipCodeMap = equipCodeMap;
            }
          }
        }
      });
      let combinationList = configList;
      combinationList.map((item) => {
        item.g7TerminalAttrVO = {
          terminalAttrList: item.terminalAttrList
        };
        delete item.terminalAttrList;
        delete item.sensorAppList;
      });
      try {
        this.loading = true;
        let res = await updateAttribute({
          combinationList
        });
        if (res.code == "OK") {
          this.$message.success("保存成功");
          this.closeTag(this.$route);
          this.handleGoBack(true);
        }
      } catch (err) {
        printError(err);
      } finally {
        this.loading = false;
      }
    },
    // 提交
    handleSaveAdd() {
      // 清除之前的错误状态
      this.cameraSelectErrors = {};
      this.doorSensorSelectErrors = {};
      this.temperatureSelectErrors = {};
      this.doorSensorEquipCodeErrors = {};
      this.temperatureEquipCodeErrors = {};

      // 紫宝盒摄像头配置校验
      if (this.isZiBaoHe == 1) {
        const cameraConfig = this.configList[
          this.clickIndex
        ].terminalAttrList.find((item) => item.requireKey === "cameraWays");

        if (cameraConfig && cameraConfig.channel.length > 0) {
          const missingChannels = [];
          let firstErrorChannel = null;

          cameraConfig.channel.forEach((channelNum) => {
            const channelKey = `CH${channelNum}`;
            if (!this.ziBaoHeCameraProductMap[channelKey]) {
              missingChannels.push(`${channelNum}路`);
              this.$set(this.cameraSelectErrors, channelKey, true);
              if (!firstErrorChannel) {
                firstErrorChannel = channelNum;
              }
            }
          });

          if (missingChannels.length > 0) {
            this.$message.error(
              `请为已选择的摄像头通道选择对应的摄像头类型：${missingChannels.join(
                "、"
              )}`
            );

            if (firstErrorChannel) {
              this.$nextTick(() => {
                const selectRef =
                  this.$refs[`cameraSelect${firstErrorChannel}`];
                if (selectRef && selectRef.length > 0) {
                  selectRef[0].focus();
                } else if (selectRef) {
                  selectRef.focus();
                }
              });
            }

            return;
          }
        }
      }

      // isZiBaoHeV2门磁配置校验
      if (this.isZiBaoHeV2) {
        const doorSensorConfig = this.configList[
          this.clickIndex
        ].terminalAttrList.find((item) => item.requireKey === "doorSensorWays");

        if (doorSensorConfig && doorSensorConfig.channel.length > 0) {
          const missingChannels = [];
          let firstErrorChannel = null;

          doorSensorConfig.channel.forEach((channelNum) => {
            const channelKey = `CH${channelNum}`;
            if (!this.ziBaoHeDoorSensorProductMap[channelKey]) {
              missingChannels.push(`${channelNum}路`);
              this.$set(this.doorSensorSelectErrors, channelKey, true);
              if (!firstErrorChannel) {
                firstErrorChannel = channelNum;
              }
            }
          });

          if (missingChannels.length > 0) {
            this.$message.error(
              `请为已选择的门磁通道选择安装位置：${missingChannels.join("、")}`
            );

            if (firstErrorChannel) {
              this.$nextTick(() => {
                const selectRef =
                  this.$refs[`doorSensorSelect${firstErrorChannel}`];
                if (selectRef && selectRef.length > 0) {
                  selectRef[0].focus();
                } else if (selectRef) {
                  selectRef.focus();
                }
              });
            }

            return;
          }
        }

        // 无线网关时，校验门磁设备号必填且不重复
        if (
          this.hasWirelessGateway &&
          doorSensorConfig &&
          doorSensorConfig.channel.length > 0
        ) {
          const missingCodeChannels = [];
          doorSensorConfig.channel.forEach((channelNum) => {
            const channelKey = `CH${channelNum}`;
            if (!this.ziBaoHeDoorSensorEquipCodeMap[channelKey]) {
              missingCodeChannels.push(`${channelNum}路`);
              this.$set(this.doorSensorEquipCodeErrors, channelKey, true);
            }
          });
          if (missingCodeChannels.length > 0) {
            this.$message.error(
              `请为已选择的门磁通道输入设备号：${missingCodeChannels.join("、")}`
            );
            return;
          }
          const doorDuplicates = this.findDuplicateEquipCodes(
            this.ziBaoHeDoorSensorEquipCodeMap,
            doorSensorConfig.channel
          );
          if (doorDuplicates.length > 0) {
            this.$message.error(
              `门磁设备号重复，请检查：${doorDuplicates.join("、")}`
            );
            return;
          }
        }
      }

      // isZiBaoHeV2温控配置校验
      if (this.isZiBaoHeV2) {
        const temperatureConfig = this.configList[
          this.clickIndex
        ].terminalAttrList.find((item) => item.requireKey === "temperatureWays");

        if (temperatureConfig && temperatureConfig.channel.length > 0) {
          const missingChannels = [];
          let firstErrorChannel = null;

          temperatureConfig.channel.forEach((channelNum) => {
            const channelKey = `CH${channelNum}`;
            if (!this.ziBaoHeTemperatureProductMap[channelKey]) {
              missingChannels.push(`${channelNum}路`);
              this.$set(this.temperatureSelectErrors, channelKey, true);
              if (!firstErrorChannel) {
                firstErrorChannel = channelNum;
              }
            }
          });

          if (missingChannels.length > 0) {
            this.$message.error(
              `请为已选择的温控通道选择安装位置：${missingChannels.join("、")}`
            );

            if (firstErrorChannel) {
              this.$nextTick(() => {
                const selectRef =
                  this.$refs[`temperatureSelect${firstErrorChannel}`];
                if (selectRef && selectRef.length > 0) {
                  selectRef[0].focus();
                } else if (selectRef) {
                  selectRef.focus();
                }
              });
            }

            return;
          }
        }

        // 无线网关时，校验温控设备号必填且不重复
        if (
          this.hasWirelessGateway &&
          temperatureConfig &&
          temperatureConfig.channel.length > 0
        ) {
          const missingCodeChannels = [];
          temperatureConfig.channel.forEach((channelNum) => {
            const channelKey = `CH${channelNum}`;
            if (!this.ziBaoHeTemperatureEquipCodeMap[channelKey]) {
              missingCodeChannels.push(`${channelNum}路`);
              this.$set(this.temperatureEquipCodeErrors, channelKey, true);
            }
          });
          if (missingCodeChannels.length > 0) {
            this.$message.error(
              `请为已选择的温控通道输入设备号：${missingCodeChannels.join("、")}`
            );
            return;
          }
          const temperatureDuplicates = this.findDuplicateEquipCodes(
            this.ziBaoHeTemperatureEquipCodeMap,
            temperatureConfig.channel
          );
          if (temperatureDuplicates.length > 0) {
            this.$message.error(
              `温控设备号重复，请检查：${temperatureDuplicates.join("、")}`
            );
            return;
          }
        }
      }

      this.updateHostAttribute();
    },
    isSelectDisabled(value, channel) {
      // 如果当前通道未被勾选，则禁用select
      if (!channel.includes(value)) {
        return true;
      }

      // 对于前6路，如果是初始有值的通道且没有被重新勾选过，则禁用select
      if (value <= 6) {
        if (
          this.initialValueChannels.includes(value) &&
          !this.reSelectedChannels.includes(value)
        ) {
          return true;
        }
      }

      // 其他情况不禁用
      return false;
    },
    handleCameraChannelChange() {
      // 处理摄像头通道变化时的逻辑
      // 获取当前选中的通道
      const currentConfig = this.configList[
        this.clickIndex
      ].terminalAttrList.find((item) => item.requireKey === "cameraWays");

      if (currentConfig) {
        // 检查哪些通道被取消勾选了，清除对应的select值
        for (let i = 1; i <= 8; i++) {
          const channelKey = `CH${i}`;
          if (!currentConfig.channel.includes(i)) {
            // 如果通道没有被勾选，清除对应的select值
            this.$set(this.ziBaoHeCameraProductMap, channelKey, null);
            // // 从重新勾选列表中移除
            // const index = this.reSelectedChannels.indexOf(i);
            // if (index > -1) {
            //   this.reSelectedChannels.splice(index, 1);
            // }
          }
        }
      }
    },
    handleItemCameraChannelChange(value) {
      this.reSelectedChannels.push(value);
    },
    clearCameraSelectError(channel) {
      this.cameraSelectErrors[channel] = false;
    },
    handleDoorSensorChannelChange() {
      const currentConfig = this.configList[
        this.clickIndex
      ].terminalAttrList.find((item) => item.requireKey === "doorSensorWays");
      if (currentConfig) {
        const maxDoor = this.doorSum || 4;
        for (let i = 1; i <= maxDoor; i++) {
          const channelKey = `CH${i}`;
          if (!currentConfig.channel.includes(i)) {
            this.$set(this.ziBaoHeDoorSensorProductMap, channelKey, null);
            this.$set(this.ziBaoHeDoorSensorEquipCodeMap, channelKey, "");
          }
        }
      }
    },
    clearDoorSensorSelectError(channel) {
      this.doorSensorSelectErrors[channel] = false;
    },
    handleTemperatureChannelChange() {
      const currentConfig = this.configList[
        this.clickIndex
      ].terminalAttrList.find((item) => item.requireKey === "temperatureWays");
      if (currentConfig) {
        const maxTemp = this.temperatureSum || 4;
        for (let i = 1; i <= maxTemp; i++) {
          const channelKey = `CH${i}`;
          if (!currentConfig.channel.includes(i)) {
            this.$set(this.ziBaoHeTemperatureProductMap, channelKey, null);
            this.$set(this.ziBaoHeTemperatureEquipCodeMap, channelKey, "");
          }
        }
      }
    },
    clearTemperatureSelectError(channel) {
      this.temperatureSelectErrors[channel] = false;
    },
    clearDoorSensorEquipCodeError(channel) {
      this.doorSensorEquipCodeErrors[channel] = false;
    },
    clearTemperatureEquipCodeError(channel) {
      this.temperatureEquipCodeErrors[channel] = false;
    },
    // 检查已勾选通道的设备号是否重复，返回重复的设备号列表
    findDuplicateEquipCodes(equipCodeMap, channel) {
      const valueCount = {};
      channel.forEach((channelNum) => {
        const code = equipCodeMap[`CH${channelNum}`];
        if (code) {
          valueCount[code] = (valueCount[code] || 0) + 1;
        }
      });
      return Object.keys(valueCount).filter((code) => valueCount[code] > 1);
    },
    // 打开选择设备弹框：type为door/temperature，channelNum为目标通道号
    openEquipCodeDialog(type, channelNum) {
      this.equipCodeDialogType = type;
      this.equipCodeDialogChannel = channelNum;
      // 默认选中当前通道已填设备号，便于改选
      const map =
        type === "door"
          ? this.ziBaoHeDoorSensorEquipCodeMap
          : this.ziBaoHeTemperatureEquipCodeMap;
      this.equipCodeDialogSelected = map[`CH${channelNum}`] || "";
      this.equipCodeDialogVisible = true;
    },
    // 判断设备号是否被同模块其他已勾选通道占用（当前通道自身值除外）
    isEquipCodeOccupied(code) {
      const requireKey =
        this.equipCodeDialogType === "door"
          ? "doorSensorWays"
          : "temperatureWays";
      const config = this.configList[this.clickIndex].terminalAttrList.find(
        (item) => item.requireKey === requireKey
      );
      if (!config) {
        return false;
      }
      const map =
        this.equipCodeDialogType === "door"
          ? this.ziBaoHeDoorSensorEquipCodeMap
          : this.ziBaoHeTemperatureEquipCodeMap;
      return config.channel.some(
        (ch) => ch !== this.equipCodeDialogChannel && map[`CH${ch}`] === code
      );
    },
    // 弹框确定：回填选中设备号到目标通道，并清除必填错误态
    confirmEquipCodeSelect() {
      const key = `CH${this.equipCodeDialogChannel}`;
      if (this.equipCodeDialogType === "door") {
        this.$set(
          this.ziBaoHeDoorSensorEquipCodeMap,
          key,
          this.equipCodeDialogSelected
        );
        this.clearDoorSensorEquipCodeError(key);
      } else {
        this.$set(
          this.ziBaoHeTemperatureEquipCodeMap,
          key,
          this.equipCodeDialogSelected
        );
        this.clearTemperatureEquipCodeError(key);
      }
      this.equipCodeDialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .edit-wrapper__body {
  .el-row {
    width: 100%;
  }
  .edit-content {
    padding: 20px 20px 2px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .form-item--1 {
    .el-form-item__content {
      width: 260px;
      .e6-vr-select,
      .el-input {
        width: 260px;
      }
    }
  }
  .form-item--2 {
    .el-form-item__content {
      width: 520px;
      .el-input {
        width: 520px;
      }
    }
  }
  .device-name {
    .e6-vr-select {
      width: 220px;
    }
  }
}
/deep/ .edit-wrapper__body {
  .camera-ways-wrapper .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    .camera-ways-item {
      flex: 0 0 20%;
      flex-shrink: 0;
    }
    .el-checkbox {
      margin-right: 10px;
    }
  }
  // 无线网关场景：通道内勾选框/位置/设备号纵向排列
  .camera-ways-wrapper.equip-code-wrapper .el-checkbox-group {
    .camera-ways-item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .el-select {
        display: block;
        width: 100%;
        margin-top: 8px;
      }
    }
  }
}

.camera-ways-item {
  .el-select.is-error {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }
  // 设备号输入框+选择设备按钮横向排列
  .equip-code-row {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 8px;
    .equip-code-select-btn {
      margin-left: 8px;
      flex-shrink: 0;
      padding: 0;
    }
  }
  .equip-code-input {
    display: block;
    width: 100%;
    margin: 8px 0 0;
    &.is-error {
      .el-input__inner {
        border-color: #f56c6c;
      }
    }
  }
  // 在equip-code-row内时去除上边距，由row容器统一控制
  .equip-code-row .equip-code-input {
    margin: 0;
    flex: 1;
  }
}
// 选择设备弹框：radio纵向排列
.equip-code-dialog-body {
  max-height: 320px;
  overflow-y: auto;
  .el-radio-group {
    display: flex;
    flex-direction: column;
    .el-radio {
      margin: 6px 0;
      white-space: normal;
      word-break: break-all;
    }
  }
}
.header-btn-box {
  display: flex;
  align-content: center;
  justify-content: space-between;
  padding: 10px;
  box-sizing: border-box;
}
.require-form {
  padding: 10px;
  .el-form-item {
    margin-bottom: 0px;
  }
}
.require-content {
  font-size: 14px;
  color: #303133;
  line-height: 24px;
  padding: 15px;
  box-sizing: border-box;
}
</style>
